<template>
  <v-container>
    <v-layout justify-center>
      <v-col
      xs="9"
      sm="9"
      md="10"
      lg="10"
      xl="9">
        <v-card
        class="mt-7"
        id="card">
    <!-- <v-card
    :width="contentsWidth"
    class="mt-7"> -->
      <v-app-bar
        absolute
        color="grey darken-1"
        dark
        scroll-target="#target"
      >
        <v-toolbar-title>
          <v-icon>
            mdi-home-city-outline
          </v-icon>
          会社概要
        </v-toolbar-title>
      </v-app-bar>
      <v-content>
        <v-layout>
          <v-sheet
          class="overflow-y-auto"
          id="target">
          <!-- <v-sheet
          :height="contentsHeight"
          class="overflow-y-auto"
          id="target"> -->
          <v-list :width="listWidth">
            <v-list-item>
              <v-list-item-icon class="mr-3">
                <v-icon color="indigo">mdi-home-city-outline</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>有限会社小西住建</v-list-item-title>
              </v-list-item-content>

            </v-list-item>

            <v-divider></v-divider>

            <v-list-item>
              <v-list-item-icon class="mr-3">
                <v-icon color="indigo">mdi-calendar</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-subtitle>設立</v-list-item-subtitle>
                <v-list-item-title>1974年11月2日</v-list-item-title>
              </v-list-item-content>

            </v-list-item>

            <v-divider class="ml-12"></v-divider>

            <v-list-item>
              <v-list-item-icon class="mr-3">
                <v-icon color="indigo">mdi-badge-account-horizontal-outline</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-subtitle>免許証番号</v-list-item-subtitle>
                <v-list-item-title>徳島県知事(10) 第663号</v-list-item-title>
              </v-list-item-content>

            </v-list-item>

            <v-list-item>
              <v-list-item-action class="mr-3"></v-list-item-action>

              <v-list-item-content>
                <v-list-item-title>不動産コンサルティング技能登録</v-list-item-title>
              </v-list-item-content>

            </v-list-item>

            <v-divider class="ml-12"></v-divider>

            <v-list-item>
              <v-list-item-icon class="mr-3">
                <v-icon color="indigo">mdi-account-circle</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-subtitle>代表</v-list-item-subtitle>
                <v-list-item-title>小西俊一</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-action class="mr-3"></v-list-item-action>

              <v-list-item-content>
                <v-list-item-subtitle>資本金</v-list-item-subtitle>
                <v-list-item-title>500万円</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider class="ml-12"></v-divider>

            <v-list-item>
              <v-list-item-icon class="mr-3">
                <v-icon color="indigo">mdi-map-marker</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-subtitle>郵便番号</v-list-item-subtitle>
                <v-list-item-title>〒770-0936</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-action class="mr-3"></v-list-item-action>

              <v-list-item-content>
                <v-list-item-subtitle>住所</v-list-item-subtitle>
                <v-list-item-title>徳島県徳島市中央通<br/>3丁目1番地</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider class="ml-12"></v-divider>

            <v-list-item>
              <v-list-item-icon class="mr-3">
                <v-icon color="indigo">mdi-phone</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-subtitle>電話番号</v-list-item-subtitle>
                <v-list-item-title><a href="tel:0886253586">088-625-3586</a></v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-action class="mr-3"></v-list-item-action>

              <v-list-item-content>
                <v-list-item-subtitle>FAX番号</v-list-item-subtitle>
                <v-list-item-title>088-652-1830</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider class="ml-12"></v-divider>

            <v-list-item>
              <v-list-item-icon class="mr-3">
                <v-icon color="indigo">mdi-home-city-outline</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-subtitle>取引先 ※敬称略、五十音順</v-list-item-subtitle>
                <v-list-item-title>
                  株式会社 大京リアルド<br/>
                  野村不動産アーバンネット 株式会社<br/>
                  三井不動産 株式会社
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          </v-sheet>
        </v-layout>
      </v-content>
    </v-card>
      </v-col>
    </v-layout>
  </v-container>
</template>

<style>
.v-list-item__title {
  white-space: normal !important;
}
.v-list-item__subtitle {
  white-space: normal !important;
}
main.v-content {
  padding-top: 60px !important;
}
</style>

<script>
export default {
  data: () => ({
    // リサイズイベント用 初期値0
    windowWidth: 0,
    contentsWidth: 0,
    listWidth: 0,
    contentsHeight: 0
  }),
  methods: {
  // 画面幅を特定し、コンテンツ幅、高さを切り替え
  // calculateWidth () {
  //   this.windowWidth = window.innerWidth
  //   if (this.windowWidth > 1000) {
  // this.contentsWidth = 950
  // this.listWidth = 950
  // this.contentsHeight = 750
  // } else if (this.windowWidth > 770) {
  // this.contentsWidth = 700
  // this.listWidth = 750
  // this.contentsHeight = 600
  // } else if (this.windowWidth > 350) {
  // this.contentsWidth = 360
  // this.listWidth = 360
  // this.contentsHeight = 750
  // } else {
  // this.contentsWidth = 270
  // this.listWidth = 270
  // this.contentsHeight = 500
  // }
  //   }
    changeListWidth () {
      var cardWidth = document.getElementById('card').clientWidth
      this.listWidth = cardWidth
    }
  },
  created () {
    // window.addEventListener('load', this.calculateWidth)
    window.addEventListener('resize', this.changeListWidth)
  },
  // DOM作成の際に画面幅特定イベントを登録
  mounted () {
    var cardWidth = document.getElementById('card').clientWidth
    this.listWidth = cardWidth
    // window.addEventListener('resize', this.calculateWidth)
    // window.addEventListener('load', this.calculateWidth)
  }
  // インスタンス破棄前にイベントの実行
  // beforeDestroy () {
  //   window.addEventListener('resize', this.calculateWidth)
  //   window.addEventListener('load', this.calculateWidth)
  // }
}
</script>
